export const envIs = env => {
  return process.env.NODE_ENV.toLowerCase() === env.toLowerCase();
};
